import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataSugerencias } from '../../noticia-new/noticia-new.component';

@Component({
  selector: 'app-sugest-slider',
  templateUrl: './sugest-slider.component.html',
  styleUrls: ['./sugest-slider.component.scss']
})
export class SugestSliderComponent implements OnInit {

  @Output() openNotiSel = new EventEmitter<any>();
  @Output() llenarDatos = new EventEmitter<any>();
  @Input() noticias: DataSugerencias[];
  selector : string = '.grid';

  constructor() { }

  ngOnInit(): void {
  }

  cambiarCategoria(nombre){
    this.openNotiSel.emit(nombre);
  }

  onScroll() {
    this.llenarDatos.emit();
  }

}
